import { commitMutation, graphql } from "react-relay";
import relayEnvironment from "../../../../../RelayEnvironment";

const CREATE_ARTICLE = graphql`
  mutation CreateArticleMutation($input: CreateArticleInput!) {
    createArticle(input: $input) {
      article {
        title
      }
    }
  }
`;

export default (
  titleEditable,
  articleContent,
  articleImageUpload,
  published,
  isTemplate,
  articleCategories,
  setSubmittingArticle,
  setArticleError,
  articleSlateId,
  playerMentionIds,
  history
) => {
  const variables = {
    input: {
      title: titleEditable.current.innerText,
      content: articleContent,
      sportId: 1,
      published: published,
      isTemplate: isTemplate,
      categories: articleCategories,
      file: articleImageUpload,
      playerMentions: playerMentionIds,
      slateId: articleSlateId,
    },
  };

  commitMutation(relayEnvironment, {
    mutation: CREATE_ARTICLE,
    variables,
    onCompleted: (content, errors) => {
      setSubmittingArticle(false);

      localStorage.removeItem("newArticleContent");
      localStorage.removeItem("newArticleTitle");

      if (!errors) {
        history.goBack();
      } else {
        setArticleError(errors[0].message);
      }
    },
    onError: (error) => {
      setArticleError(JSON.stringify(error));
      setSubmittingArticle(false);
    },
  });
};
